// Kept out of components/onboarding.tsx: the account route's validateSearch
// reads it, and that part of a route ships in every page's first download.

/** Why a refused finish sent the ambassador back to an earlier step. */
export type OnboardingReason = "handle_required" | "categories_required";
export function isOnboardingReason(v: unknown): v is OnboardingReason {
  return v === "handle_required" || v === "categories_required";
}
